import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { updateShippingAddress, openModal } from '../../store/actions/modal';

import './F1-account-information.scss';

class F1AccountInformation extends Component {
	state = {
		content: {
			title: '',
			
			email: '',
			phone: '',
			
			labels: {
				email: '',
				phone: '',
				company: '',
				shippingWarning: '',
				name: ''
			},
		},
	}

	componentDidMount() {
		const { data, dispatch } = this.props;
		
		this.setState({ content: { ...data.content } });
		dispatch(updateShippingAddress(data.content.shipping ));
	}

	onClick = (event) => {
		const { dispatch } = this.props;
		const { data } = this.props;
		const { formModal, content } = data;
	
		const jsonString = JSON.stringify({ formModal });
		event.preventDefault();
		dispatch(openModal('form', { formModalData: jsonString }));
	}


	render() {
		const {
			content,
		} = this.state;

		const {
			shipping: {
				name,
				company,
				address1,
				address2,
				city,
				country,
				stateProvince,
				zipPostal,
				phone,
				email,
				accountEmail,
				accountCompany,
				accountPhone,
				accountAddress1,
				accountAddress2,
				accountCity,
				accountStateProvince,
				accountZipPostal,
				accountCountry,
				accountName
			},
			data: {
				formModal: {
					country: {
						options,
					},
				},
			},
		} = this.props;
		const emailField = email ? <p className="F1-account-information__email">{accountEmail}</p> : null;
		const phoneField = phone ? <p className="F1-account-information__telephone">{accountPhone}</p> : null;
		const companyField = company ? <p className="F1-account-information__company">{accountCompany}</p> : null;
		const secondAddress = address2 ? (
			<Fragment>
				<br />
				{address2}
			</Fragment>
		) : null;

		const countryName = (Array.isArray(options)) ? options.find((c) => {
			return c.value === accountCountry;
		}) : null;

		const addressBlock = (
			(address1 && address1 !== '')
			&& (city && city !== '')
			&& (zipPostal && zipPostal !== '')
			&& (country && country !== '')
		) ? (
				<p className="F1-account-information__address">
					{company}
					<br/>
					{address1}
					{secondAddress}
					<br />
					{city}
					,&nbsp;
					{stateProvince && stateProvince !== 'n/a' ? stateProvince : ''}
					&nbsp;
					{zipPostal}
					<br />
					{countryName ? countryName.label : country}
					<br />
					{email}
					<br />
					{phone}
				</p>
			) : (
				<p className="F1-account-information__address">
					<button type="button" className="btn btn--primary btn--small F1-account-information__add" onClick={this.onClick}>
						{content.labels.addButton}
					</button>
				</p>
			);

		return (
			<div className="container">
				<div className="F1-account-information__data-container shipping-info container">
					<div className="F1-account-information__name-and-address-container">
						<p className="F1-account-information__name F1-account-information__label">{name}</p>
						{addressBlock}
						<p class="F1-account-information__warning">
							{content.labels.shippingWarning}
							</p>
					</div>
					<div className="F1-account-information__mid-data-container">
						<div className="F1-account-information__email-and-password-container F1-account-information__cell">
							<p className="F1-account-information__label">{content.labels.name}</p>
							{accountName}
						</div>
						<div className="F1-account-information__email-and-password-container F1-account-information__cell">
							<p className="F1-account-information__label">{content.labels.email}</p>
							{emailField}
						</div>
						<div className="F1-account-information__telephone-container F1-account-information__cell">
							<p className="F1-account-information__label">{content.labels.phone}</p>
							{phoneField}
						</div>
						<div className="F1-account-information__company-container F1-account-information__cell">
							<p className="F1-account-information__label">{content.labels.company}</p>
							{companyField}
						</div>
					</div>
					<div className="F1-account-information__edit-container">
						<a href="/" className="F1-account-information__edit btn btn--secondary" onClick={this.onClick}>
							{content.labels.editButton}
							<span className="btn__arrow-angle" />
						</a>
					</div>
				</div>
			</div>
		);
	}
}

F1AccountInformation.propTypes = {
	data: PropTypes.shape({}),
	dispatch: PropTypes.func,
	shipping: PropTypes.shape({}),
};

F1AccountInformation.defaultProps = {
	data: {
		content: {
			title: '',
			email: '',
			phone: '',
			labels: {
				email: '',
				phone: '',
				company: '',
			},
		},
	},
	dispatch: () => { },
	shipping: {},
};

const mapStateToProps = (state) => {
	return {
		shipping: state.modal.shippingAddress || {},
	};
};

export default connect(mapStateToProps)(F1AccountInformation);
